import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-SidebarLibrary",
  "use": "svg-icon-SidebarLibrary-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"svg-icon-SidebarLibrary\"><g fill=\"none\"><path opacity=\".5\" d=\"M0 0h24v24H0z\" /><path d=\"M5 1h14a1 1 0 0 1 0 2H5a1 1 0 1 1 0-2zM4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zM3 9h18a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1z\" fill=\"#D8D8D8\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol